import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { Header } from './header';

export const LoadingPanel = props => (
  <div className="notification-queue-loading-panel">
    {props.isUINext && (<Header {..._.omit(props.header, 'text')} isUINext i18n={props.i18n} />)}
    <div className="blocker-indicator">
      <div className="blocker-image" />
      {props.isUINext && (
        <span className="blocker-text">
          {props.i18n.getString(_TL_('...Loading...'))}
        </span>
      )}
    </div>
  </div>
);

LoadingPanel.propTypes = {
  header: PropTypes.instanceOf(Object).isRequired,
  isUINext: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
